import React from 'react';
import { services } from '../data/mock';
import { Stethoscope, Video, Activity, FlaskConical, Users, Sparkles } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const Services = () => {
  const serviceCategories = [
    {
      key: 'comprehensiveCare',
      icon: Stethoscope,
      data: services.comprehensiveCare
    },
    {
      key: 'telemedicine',
      icon: Video,
      data: services.telemedicine
    },
    {
      key: 'specializedTreatments',
      icon: Sparkles,
      data: services.specializedTreatments
    },
    {
      key: 'preventative',
      icon: Activity,
      data: services.preventative
    },
    {
      key: 'laboratory',
      icon: FlaskConical,
      data: services.laboratory
    },
    {
      key: 'advisory',
      icon: Users,
      data: services.advisory
    }
  ];

  return (
    <section id="services" className="section-padding bg-white">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <p className="text-sm uppercase tracking-widest text-[#b8860b] font-medium mb-4">
            Medical Services
          </p>
          <h2 className="heading-1 text-[#0f172a] mb-6">
            Comprehensive Care Tailored to You
          </h2>
          <p className="body-regular text-[#475569]">
            From general medicine to specialized consultations, every service is delivered with 
            clinical precision and genuine compassion.
          </p>
        </div>

        {/* Services Accordion */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {serviceCategories.map((category, index) => (
              <AccordionItem 
                key={category.key} 
                value={category.key}
                className="border-b border-[#e2e8f0]"
              >
                <AccordionTrigger className="py-6 hover:no-underline group">
                  <div className="flex items-center gap-4 text-left">
                    <div className="w-11 h-11 border-2 border-[#0f172a] flex items-center justify-center transition-all group-hover:bg-[#0f172a]">
                      <category.icon size={20} className="text-[#0f172a] transition-colors group-hover:text-white" />
                    </div>
                    <span className="heading-3 text-[#0f172a]">
                      {category.data.title}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pb-8">
                  {category.data.items ? (
                    <div className="space-y-6 pl-14">
                      {category.data.items.map((item, itemIndex) => (
                        <div key={itemIndex} className="border-l-2 border-[#b8860b] pl-6">
                          <h4 className="text-base font-semibold text-[#0f172a] mb-2">
                            {item.name}
                          </h4>
                          <p className="body-regular text-[#475569] mb-3">
                            {item.description}
                          </p>
                          {item.idealFor && (
                            <div className="mt-3">
                              <span className="text-xs uppercase tracking-wider text-[#64748b] block mb-2">
                                Ideal for:
                              </span>
                              <ul className="flex flex-wrap gap-2">
                                {item.idealFor.map((use, i) => (
                                  <li key={i} className="text-sm text-[#475569] bg-[#f8fafc] px-3 py-1 border border-[#e2e8f0]">
                                    {use}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                          {item.note && (
                            <p className="text-sm italic text-[#64748b] mt-2">
                              {item.note}
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="pl-14">
                      <p className="body-regular text-[#475569] mb-4">
                        {category.data.description}
                      </p>
                      {category.data.notes && (
                        <ul className="space-y-2">
                          {category.data.notes.map((note, i) => (
                            <li key={i} className="text-sm text-[#64748b] flex items-start gap-2">
                              <span className="text-[#b8860b]">•</span>
                              {note}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default Services;
